import React, { useEffect, useState } from "react";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import { Pagination, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "../../../../../utils/hooks";
import { useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import { curStateMiniGame } from "../../../../../Redux/selector";
import { getDataRankingMiniGame } from "../../../../../Redux/futures/mini-game/action";
import iconRankTop1 from "../../../../../assets/images/Mini-Game/rank-top-1.png";
import iconRankTop2 from "../../../../../assets/images/Mini-Game/rank-top-2.png";
import iconRankTop3 from "../../../../../assets/images/Mini-Game/rank-top-3.png";
import iconRule from "../../../../../assets/images/Mini-Game/icon-rule.png";
import styled from "styled-components";
import moment from "moment";

const SHOW_ICON_RULE_START =  moment("2025-01-01 00:00:00");
const SHOW_ICON_RULE_END =  moment("2026-01-31 23:59:59");
export default function ComponentPiece({ isOpen, setIsOpen = () => {} }) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(`(max-width: 486px)`);
  const [isLoader, setIsLoader] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { dataRankingMini = [] } = useSelector(curStateMiniGame);
  const [sortedData, setSortedData] = useState([]);
  const [isShowPopupRule, setIsShowPopupRule] = useState(false);
  const [showIconRule, setShowIconRule] = useState(false);

  useEffect(() => {
      const checkAndUpdateMarquee = () => {
        const now = moment();
        const shouldShow = now.isBetween(
          SHOW_ICON_RULE_START,
          SHOW_ICON_RULE_END
        );
        setShowIconRule(shouldShow);
      };
  
      checkAndUpdateMarquee();
  
      const interval = setInterval(checkAndUpdateMarquee, 30000);
  
      return () => clearInterval(interval);
    }, []);
  
  useEffect(() => {
    setIsLoader(true);
    dispatch(getDataRankingMiniGame());
    setTimeout(() => {
      setIsLoader(false);
    }, [400]);

    return () => {
      clearTimeout();
    };
  }, []);

  const handleRankingImage = (index) => {
    // display top 3 winners from sorted data, item with index 0 is the top winner
    switch (index) {
      case 0:
        return (
          <img src={iconRankTop1} alt="rank-top-1" className="ranking-icon" />
        );
      case 1:
        return (
          <img src={iconRankTop2} alt="rank-top-2" className="ranking-icon" />
        );
      case 2:
        return (
          <img src={iconRankTop3} alt="rank-top-3" className="ranking-icon" />
        );
      default:
        return <span className="rank-num rank-num__minigame">{index + 1}</span>; // For other ranks, just display the index + 1
    }
  };

  useEffect(() => {
    if (dataRankingMini && dataRankingMini.length > 0) {
      const sorted = [...dataRankingMini].sort((a, b) => b.num - a.num);
      // Add ranking image to each record
      sorted.forEach((record, index) => {
        record.index = handleRankingImage(index);
      });
      setSortedData(sorted);
    } else {
      setSortedData([]);
    }
  }, [dataRankingMini, currentPage]);

  const highlightRow = (record) => {
    return +record.its_me === 1 ? "highlight-row" : "";
  };

  if (isShowPopupRule) {
    const renderRanking = t("mini_game.pop_up_rule.invite_leaderboard_rules_update", {
      returnObjects: true,
    });
    const dataArrayRanking = Object.entries(renderRanking).map(
      ([section, value]) => ({
        section,
        ...value,
      })
    );

    return (
      <Container>
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini content-rule-ranking">
              Invite လုပ်ပြီး ဆုရရှိရန် စည်းကမ်းများ{" "}
            </div>
          </div>
          <div className="box-content-minigame-popup__container box-content-minigame-popup__scroll">
            <div className="box-content-minigame-popup">
              {dataArrayRanking.map((item, index) => {
                return (
                  <div
                    className="container-minigame-popup-ranking"
                    key={`ranking_${index}`}
                  >
                    <div className="title-popup-mini sub-title">
                      {/* {item?.title} */}
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.title }}
                      />
                    </div>
                    <div className="container-content-rule-mini">
                      <div className="mini-rule-popup-content">
                        <div
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                        {/* {item.content} */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      </Container>
    );
  }

  return (
    <Container>
      <div className="header-mini-popup-rule">
        <img src={bgHeader} alt="" className="img-rule-mini" />
        <div className="content-rule-mini">
          {t("mini_game.pop_up_ranking.title")}
        </div>

        {showIconRule && (
          <img
            src={iconRule}
            onClick={() => setIsShowPopupRule(true)}
            alt=""
            className="icon-rule-minigame scale-hover-item"
          />
        )}
      </div>

      <Table
        className="table-winner"
        dataSource={sortedData.slice((currentPage - 1) * 10, currentPage * 10)}
        loading={isLoader}
        pagination={false}
        scroll={{
          y: 365,
        }}
        rowClassName={highlightRow}
      >
        <Table.Column
          title={t("mini_game.pop_up_ranking.no")}
          dataIndex="index"
          key="index"
          align="center"
          width={isMobile ? "20%" : "15%"}
        />

        <Table.Column
          title={t("event_thingyan.pop_up.isdn")}
          dataIndex="isdn"
          key="isdn"
        />

        <Table.Column
          title={t("mini_game.pop_up_ranking.number_of_pieces")}
          dataIndex="num"
          key="num"
          render={(num) => {
            return (
              <>
                <div>{num}</div>
              </>
            );
          }}
        />
      </Table>

      <div className="pagination-popup-his__mini-game mt-page-20">
        <Pagination
          current={currentPage}
          pageSize={10}
          total={sortedData?.length || 0}
          onChange={(page) => setCurrentPage(page)}
          showSizeChanger={false}
          itemRender={(page, type, originalElement) => {
            if (type === "prev") {
              return (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                  className="action-table-mini-game"
                >
                  ←{" "}
                  <span className="action-table-mini-game-content">
                    {t("mini_game.pop_up_activity_history.prev")}
                  </span>
                </span>
              );
            }
            if (type === "next") {
              return (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                  className="action-table-mini-game"
                >
                  <span className="action-table-mini-game-content">
                    {t("mini_game.pop_up_activity_history.next")}
                  </span>{" "}
                  →
                </span>
              );
            }
            return originalElement;
          }}
        />
      </div>
    </Container>
  );
}

const Container = styled.div`
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  .box-content-minigame-popup__container.box-content-minigame-popup__scroll {
    max-height: inherit !important;
    padding-right: 0px !important;
    overflow-y: auto !important;
  }

  .title-popup-mini.sub-title {
    font-size: 16px;
  }

  .mini-rule-popup-content {
    font-size: 13px;
  }

  .icon-rule-minigame {
    position: absolute;
    top: 30px;
    right: -27px;
    cursor: pointer;
  }

  .mt-page-20 {
    margin-top: 20px;
  }

  .mini-tab-popup {
    margin-bottom: 15px;
  }

  .minigame-rank-me {
    margin: 20px 0;
    .table-winner .ant-table-tbody > tr > td {
      background-color: #fdd7bc !important;
    }
    table {
      border: 1px solid white !important;
      border-radius: 10px;
      overflow: hidden;

      .ant-table-tbody > tr > td {
        border-bottom: 0px !important;
      }
    }
  }

  .table-winner .ant-table-body {
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  .table-winner .ant-table-body::-webkit-scrollbar {
    width: 6px;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-track {
    background: transparent;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 5px;
  }
  .table-winner .ant-table-body::-webkit-scrollbar-button {
    display: none;
  }

  @media (max-width: 576px) {
    .ant-table-wrapper .ant-table-thead > tr > th,
    .ant-table-wrapper .ant-table-tbody > tr > td {
      padding: 12px 4px;
    }

    .icon-rule-minigame {
      right: 0;
    }

  }
  .ranking-icon {
    height: 25px;
  }

  @media (max-width: 400px) {
    .icon-rule-minigame {
      right: 8%;
    }
  }
`;
